import { Badge } from "@/components/ui/badge";
import { Check, Flame, Soup, UtensilsCrossed } from "lucide-react";

const STEPS = [
    { key: "received", label: "Received", icon: UtensilsCrossed },
    { key: "preparing", label: "Preparing", icon: Soup },
    { key: "ready", label: "Ready", icon: Flame },
    { key: "served", label: "Served", icon: Check },
];

export function statusColor(status) {
    const map = {
        received: "bg-[hsl(var(--status-new)/0.18)] text-foreground border-[hsl(var(--status-new)/0.3)]",
        preparing: "bg-[hsl(var(--status-preparing)/0.18)] text-foreground border-[hsl(var(--status-preparing)/0.3)]",
        ready: "bg-[hsl(var(--status-ready)/0.18)] text-foreground border-[hsl(var(--status-ready)/0.3)]",
        served: "bg-[hsl(var(--status-served)/0.18)] text-foreground border-[hsl(var(--status-served)/0.3)]",
    };
    return map[status] || "";
}

export default function OrderTimeline({ status }) {
    const currentIdx = STEPS.findIndex(s => s.key === status);
    return (
        <div className="flex items-center gap-1.5" data-testid="order-status-timeline">
            {STEPS.map((step, idx) => {
                const Icon = step.icon;
                const done = idx <= currentIdx;
                const active = idx === currentIdx;
                return (
                    <div key={step.key} className="flex-1 min-w-0" data-testid="order-status-item">
                        <div className={`h-1.5 rounded-full ${done ? "bg-[hsl(var(--brand-terracotta))]" : "bg-muted"}`} />
                        <div className={`mt-1 inline-flex items-center gap-1 text-[11px] ${active ? "text-foreground font-medium" : "text-muted-foreground"}`}>
                            <Icon className="h-3 w-3" /> {step.label}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
